// extracted by mini-css-extract-plugin
export var active = "_96-d";
export var blink = "_96-e";
export var container = "_96-5";
export var controls = "_96-0";
export var controlsRight = "_96-1";
export var fakeCursor = "_96-c";
export var hidden = "_96-b";
export var quillContainerSmall = "_96-7";
export var quillEditor = "_96-6";
export var quillEditorSmall = "_96-8";
export var quillFormatButtons = "_96-a";
export var quillToolbar = "_96-9";
export var removePadding = "_96-2";
export var state = "_96-3";
export var stateTitle = "_96-4";